import memoize from 'lodash/memoize'

if (typeof window.ga === 'function') {
  const frame = document.getElementById('course')
  const ga = window.ga

  window.rise = function (Runtime) {
    console.debug('Initializing Rise runtime')
    const category = 'Course'
    const label = frame.contentDocument.title

    Runtime.finish = memoize(function (progress) {
      const action = progress === 100 ? 'finish' : 'progress'
      console.debug(action, progress)

      ga('send', 'event', category, action, label, progress)

      return true
    })
  }

  frame.onload = function () {
    document.title = frame.contentDocument.title
  }
}

/**
 * To enable tracking in Rise courses, add the following code after root.Runtime:
 *
 * @js root.parent && typeof root.parent.rise === 'function' && root.parent.rise(root.Runtime)
 */
